"use strict";Object.defineProperty(exports, "__esModule", {value: true});/* The editor's rules and words: when a form may go to an admin, what each
 * page's field-finding progress reads, and how fields are named in the list. */


/* Ask an admin and Publish unlock once the form has a field, every field has a
 * label and no yellow field is left (the server's publishProblem). */
 const canSendForPublish = (fields) =>
  fields.length > 0 && fields.every(f => f.label.trim() !== '' && !f.check); exports.canSendForPublish = canSendForPublish

 const TYPE_NAMES = {
  text: 'Text',
  date: 'Date',
  time: 'Time',
  checkbox: 'Checkbox',
  choice: 'Choice',
  initials: 'Initials',
  signature: 'Signature',
  rows: 'Repeatable rows',
}; exports.TYPE_NAMES = TYPE_NAMES
 const FIELD_TYPES = Object.keys(exports.TYPE_NAMES) ; exports.FIELD_TYPES = FIELD_TYPES

 const FILLER_NAMES = { family: 'Family', staff: 'Staff', auto: 'Auto' }; exports.FILLER_NAMES = FILLER_NAMES

/* A page stops reading as "Finding fields…" when nothing about it changed for this long. */
 const STALE_MS = 60000; exports.STALE_MS = STALE_MS






/* Folds a notice's pages into what the editor holds, stamping changed pages. */
 const mergeProgress = (
  held, pages, now,
) => {
  const next = { ...held }
  pages.forEach(p => {
    const old = held[p.Page]
    const changed = !old || old.Fields !== p.Fields || old.State !== p.State
    next[p.Page] = { ...p, at: changed ? now : old.at }
  })
  return next
}; exports.mergeProgress = mergeProgress

 const fieldsWord = (n) => `${n} ${n === 1 ? 'field' : 'fields'}`; exports.fieldsWord = fieldsWord

/* What a page under detection says, or null once there's nothing to say. */
 const pageProgressNote = (p, now) => {
  if (!p) return null
  if (p.State === 'none') return { text: 'No fields found on this page. Place them yourself.', isProblem: true }
  if (p.State === 'failed' || (p.State === 'finding' && now - p.at > exports.STALE_MS)) {
    return { text: "Couldn't finish this page. Place the rest yourself.", isProblem: true }
  }
  if (p.State === 'finding') return { text: `Finding fields… ${exports.fieldsWord.call(void 0, p.Fields)} so far`, isProblem: false }
  // A page that got its fields elsewhere meanwhile (another run, a person) adds none.
  if (!p.Fields) return null
  return { text: `${exports.fieldsWord.call(void 0, p.Fields)} found`, isProblem: false }
}; exports.pageProgressNote = pageProgressNote

/* "Fields found on {done} of {total} pages" while any page is still being read. */
 const detectionHeader = (progress, now) => {
  const pages = Object.values(progress)
  const finding = pages.filter(p => p.State === 'finding' && now - p.at <= exports.STALE_MS)
  if (!finding.length) return null
  return `Fields found on ${pages.length - finding.length} of ${pages.length} pages`
}; exports.detectionHeader = detectionHeader

/* The publish dialog's "Families fill" line. */
 const familiesFill = (fields) => {
  const family = fields.filter(f => f.filler === 'family')
  const tables = family.filter(f => f.type === 'rows').length
  const signs = family.some(f => f.type === 'signature')
  const others = family.filter(f => f.type !== 'rows' && f.type !== 'signature').length
  const parts = []
  if (others) parts.push(exports.fieldsWord.call(void 0, others))
  if (tables) parts.push(`${tables} ${tables === 1 ? 'table' : 'tables'} with repeatable rows`)
  if (!parts.length) return signs ? 'A signature' : 'Nothing'
  return signs ? `${parts.join(', ')}, then a signature` : parts.join(', ')
}; exports.familiesFill = familiesFill

/* The publish dialog's "Staff fill before sending" line. */
 const staffFill = (fields) =>
  fields.filter(f => f.filler === 'staff').map(f => f.label).join(', ') || 'Nothing'; exports.staffFill = staffFill
